import styled from 'styled-components';
import { Form as AntForm } from 'antd';

export const StyledForm = styled(AntForm)`
  flex: 1;
`;

export const StyledFormItem = styled(AntForm.Item)`
  @media (max-width: 1280px) {
    margin-bottom: calc(var(--spacing-small) * 2);
  }
`;

